var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled from '@mui/material/styles/styled';
import { MenuItem, Box, ListItemIcon, ListSubheader } from '@mui/material';
import Popover from '../Popover';
var MenuItemRoot = styled(MenuItem)({
    fontSize: 14,
    padding: '7px 16px'
});
var ActionMenuItem = function (_a) {
    var children = _a.children, icon = _a.icon, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (React.createElement(MenuItemRoot, { onClick: onClick, disabled: disabled },
        icon && React.createElement(ListItemIcon, null, icon),
        children));
};
var ActionMenu = function (props) {
    var actions = props.actions, popupProps = __rest(props, ["actions"]);
    var getMenuItems = function (actions) { return actions.map(function (actionsItem) {
        var text = actionsItem.text, icon = actionsItem.icon, onClick = actionsItem.onClick, actions = actionsItem.actions, disabled = actionsItem.disabled;
        if (actions && actions.length) {
            return __spreadArray([
                React.createElement(ListSubheader, { key: text }, text)
            ], getMenuItems(actions), true);
        }
        var handleMenuItemClick = function (event) {
            event.stopPropagation();
            if (onClick && typeof onClick === 'function') {
                onClick(popupProps);
            }
        };
        return (React.createElement(ActionMenuItem, { key: text, icon: icon, onClick: handleMenuItemClick, disabled: disabled }, text));
    }); };
    return (React.createElement(Box, { sx: { minWidth: 40, py: 0.5 } }, getMenuItems(actions)));
};
var Popactions = function (props) {
    var children = props.children, actions = props.actions, popoverProps = __rest(props, ["children", "actions"]);
    var content = function (popupProps) { return React.createElement(ActionMenu, __assign({}, popupProps, { actions: actions })); };
    return (React.createElement(Popover, __assign({ content: content }, popoverProps), children));
};
Popactions.defaultProps = {
    trigger: 'hover',
    actions: [],
    arrow: false,
};
export default Popactions;
